import { useEffect, useState } from "react";

import { IconButton, useTheme } from "@mui/material";

import { useScriptInject } from "hooks/useScriptInject";

export const GATEWAY_DRAWER_BUTTON_LABEL = "Open gateway drawer";

const GATEWAY_DRAWER_SRC =
  "/mfe/mdc-gateway-drawer/build/mdc-gateway-drawer.js";

export const GatewayDrawer = () => {
  const theme = useTheme();
  const [drawerDisplayStyle, setDrawerDisplayStyle] = useState("none");

  useScriptInject({
    id: "gatewayDrawer",
    type: "module",
    src: GATEWAY_DRAWER_SRC,
  });

  useEffect(() => {
    const handleGatewayDrawerLoaded = (event: CustomEventInit) => {
      setDrawerDisplayStyle(event.detail.message ? "inherit" : "none");
    };
    window.addEventListener("gateway-drawer-loaded", handleGatewayDrawerLoaded);

    return () =>
      window.removeEventListener(
        "gateway-drawer-loaded",
        handleGatewayDrawerLoaded
      );
  }, []);

  return (
    <IconButton
      aria-label={GATEWAY_DRAWER_BUTTON_LABEL}
      color={theme.palette.mode === "light" ? "default" : "primary"}
      style={{ display: drawerDisplayStyle }}
    >
      <gateway-drawer
        data-testid="gateway-drawer"
        style={{ height: "24px", width: "24px" }}
        iconColor={
          theme.palette.mode === "light"
            ? theme.palette.action.active
            : theme.palette.primary.main
        }
      />
    </IconButton>
  );
};
